/* eslint-disable @typescript-eslint/naming-convention */import classnames from 'classnames';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { 
  ButtonLink, 
  ButtonLooks, 
  ButtonSizes, 
  DropdownLooks, 
  ListItem, 
  StandardDropdown 
} from '@brandfolder/react';

import { useFetch } from '@api/ApiHelper';
import { BrandguideListResponse } from '@api/v4/brandguides/brandguidesTypes';

import classes from './styles/brandguide-header-list.module.scss';

export const BrandguideHeaderList: FunctionComponent = () => {

  const { loading, response } = useFetch<BrandguideListResponse>({
    url: `/api/v4/${BFG.resource.type}s/${BFG.resource.key}/brandguides`
  });

  const [options, setOptions] = useState<ListItem[]>([]);

  const renderOptions = (): void => {
    const listItems: ListItem[] = response && response.data.map((brandguide) => {
      return {
        children: (
          <ButtonLink 
            className={classes.brandguideButtonLink} 
            fullWidth={true} href={`${BFG.brandguideUrl}/${brandguide.attributes.slug}`} 
            look={ButtonLooks.Default} 
            size={ButtonSizes.Large} 
            target="_blank"
          >
            {brandguide.attributes.name}
          </ButtonLink>
        ), 
        key: brandguide.id
      };
    });
    setOptions(listItems);
  };

  useEffect(() => {
    if (response) {
      renderOptions();
    }
  }, [response]);

  const brandguides = response?.data;

  const hasNoBrandguides = brandguides?.length === 0;
  if (hasNoBrandguides === true) return null;
  
  const hasOneBrandguide = brandguides?.length === 1;
  const brandguideText = hasOneBrandguide ? bfTranslate('Brandguide') : bfTranslate('Brandguides');
  const dropdownText = brandguides ? `${brandguides.length} ${brandguideText}` : '';

  return (
    <StandardDropdown
      buttonProps={{ className: classes.brandguideDropdownButton, endIconProps: { className: classes.caret } }}
      className={classnames(classes.brandguideDropdown)}
      id="brandguide-dropdown"
      labels={{
        loaderLabel: 'Loading'
      }}
      listItems={options}
      listProps={{
        style: {
          width: 270
        }
      }}
      loading={loading}
    >
      {dropdownText}
    </StandardDropdown>
  );
};